export default __webpack_public_path__ + "static/media/Todo-List.196d6a18.png";